module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "fm2"
    }
  }, [_vm._v("…but oh my desert"), _c('br'), _vm._v("yours is the only death I cannot bear.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Richard Shelton")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Resist much. Obey little.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Walt Whitman")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Now. Or never.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Thoreau")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bdafd2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795317361_epub_fm2_r1.vue
// module id = 75
// module chunks = 0